<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div>
        <el-button type="primary">话题管理</el-button>
        <el-button type="text" @click="$router.push('/topic')"
          >banner管理</el-button
        >
        <el-button type="text" @click="$router.push('/notify')"
          >系统通知</el-button
        >
      </div>
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="showEdit"
        >发布话题</el-button
      >
    </div>
    <div style="margin-bottom: 10px" class="fesvd">
      <el-radio-group v-model="table.params.status" @input="getTable">
        <el-radio-button :label="1">讨论中</el-radio-button>
        <el-radio-button :label="2">已隐藏</el-radio-button>
      </el-radio-group>
      <el-switch
        active-color="#13ce66"
        @change="change"
        v-model="is_open"
        :active-value="1"
        :inactive-value="2"
        active-text="开启话题功能"
        inactive-text="关闭话题功能"
      >
      </el-switch>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <div class="VTable__wrap">
        <div class="shadow main" ref="main">
          <el-table
            v-loading="table.loading"
            highlight-current-row
            row-key="id"
            :data="table.data"
            :height="height"
            :header-cell-style="{ background: '#30C3B1', color: '#fff' }"
            @sort-change="handleSort"
          >
            <el-table-column type="index" label="顺序" width="80">
            </el-table-column>
            <el-table-column prop="title" label="话题标题" width="250">
            </el-table-column>
            <el-table-column
              prop="simple_desc"
              label="内容"
              :formatter="formatter"
            >
            </el-table-column>
            <el-table-column
              prop="view_num"
              label="浏览量"
              width="120"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column
              prop="like_num"
              label="点赞量"
              width="120"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column
              prop="comment_num"
              label="评论量"
              width="120"
              sortable="custom"
            >
              <template v-slot="{ row }">
                <div class="fewa">
                  <div class="few" v-if="row.unread == 1"></div>
                  {{ row.comment_num }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="share_num"
              label="分享量"
              width="120"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="140">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="240">
              <template v-slot="{ row }">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="showEdit(row)"
                  >编辑</el-button
                >
                <el-button type="text" @click="showDetail(row)">查看</el-button>
                <el-button
                  type="text"
                  @click="updateStatus(row, table.params.status == 1 ? 2 : 1)"
                  >{{
                    table.params.status == 1 ? "隐藏" : "取消隐藏"
                  }}</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  class="delBtn"
                  @click="handleDetail(row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination__wrap">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="table.params.page"
            :page-size="table.params.count"
            :total="table.total"
            :page-sizes="[10, 20, 50, 100, 150]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <edit ref="edit" @refresh="getTable"></edit>
    <detail ref="detail" @getDetail="getTable"></detail>
  </div>
</template>

<script>
import Edit from "./components/Edit.vue";
import Detail from "./components/Detail.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "notifyList",
  mixins: [mixinTable],
  components: {
    Edit,
    Detail,
  },
  data() {
    return {
      height: 500,
      table: {
        loading: false,
        params: {
          status: 1,
          page: 1,
          count: 10,
          desc: "",
          sort: "",
        },
        data: [],
        total: 0,
      },
      is_open: 2,
    };
  },
  created() {
    this.getTable();
  },
  mounted() {
    this.$nextTick(() => {
      this.height = this.$refs.main.offsetHeight || 500;
    });
  },
  methods: {
    formatter(row) {
      return row.simple_desc.length > 50
        ? row.simple_desc.substring(0, 50) + "..."
        : row.simple_desc;
    },
    handleSort({ column, prop, order }) {
      console.log(column, prop, order);
      this.table.params.sort =
        { view_num: 1, like_num: 2, comment_num: 3, share_num: 4 }[prop] || 1;

      if (order == "descending") {
        this.table.params.desc = 1;
      } else if (order == "ascending") {
        this.table.params.desc = 0;
      } else {
        this.table.params.desc = "";
        this.table.params.sort = "";
      }
      this.getTable();
    },
    getTable() {
      this.$http
        .get("/admin/topic/list", { params: this.table.params })
        .then((res) => {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.is_open = res.data.is_open;
        });
    },
    showEdit(row) {
      let dom = this.$refs.edit;
      dom.toggle(true);
      if (!!row.id) {
        dom.getDetail(row);
      }
      dom = null;
    },
    showDetail(row) {
      this.$refs.detail.getDetail(row);
    },
    // 删除
    handleDetail(row) {
      this.$confirm("请确认删除操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http.post("/admin/topic/delete", { id: row.id }).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    updateStatus(row, status) {
      this.$confirm(
        status == 1
          ? "取消隐藏后用户端将可以继续讨论确认取消隐藏吗?"
          : "隐藏后用户端将不再展示该话题，确认隐藏吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          this.$http
            .post("/admin/topic/updateStatus", { id: row.id, status })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.getTable();
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    change(v) {
      this.$http
        .post("/admin/topic/setTopic", { is_open: this.is_open })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功！");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;
  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
    .VTable__wrap {
      display: flex;
      flex-direction: column;
      height: 100%;
      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .main {
        flex: 1;
        margin-bottom: 15px;
      }
      .pagination__wrap {
        text-align: right;
        padding: 0 50px;
      }
    }
  }
}
.fewa {
  display: flex;
  align-items: center;
}
.few {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #fa6060;
  margin: 0 5px 0 0;
}
.fesvd {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>